import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { reportTemplatePlayer } from 'cccisd-laravel-appdefs';
import { Report, Page, BrowserOnly } from 'cccisd-laravel-report';
import Loader from 'cccisd-loader';
import { client } from 'cccisd-apollo';
import _format from 'date-fns/format';

import widgets from '../widgets/widgets.js';
import ReportHeader from '../../common/components/ReportHeader';
import NoGroupRole from '../../common/components/NoGroupRole';
import filterFields from '../../common/filterFields.js';
import { getActualFields } from '../../common/helpers.js';
import PrintView from '../../common/components/PrintView';

import reportStyle from '../../common/reportStyle.css';
import query from './metrics.graphql';

const Component = props => {
    const [headerProps, setHeaderProps] = useState(null);
    const [loading, setLoading] = useState(true);
    const [noProgress, setNoProgress] = useState(null);
    const [showPrintMode, setShowPrintMode] = useState(false);

    const { titleAndDescription, mainCharts, progressCharts } = props.widgets;
    const participantPawnId = props.filters.participant;

    useEffect(() => {
        // run metrics query
        if (noProgress === true) {
            setNoProgress(false);
        }
        (async () => {
            try {
                await client
                    .query({
                        query,
                        fetchPolicy: 'network-only',
                        variables: {
                            pawnId: +participantPawnId,
                        },
                    })
                    .then(response => {
                        const participant = response.data.roles.participant.assignmentProgressList.length > 0;

                        const group =
                            participant && participant
                                ? response.data.roles.participant.assignmentProgressList[0].pawn.parentRoles.client
                                : '';

                        const startDate =
                            participant && participant ? response.data.roles.participant.summary.earliestCompleted : '';

                        const endDate =
                            participant && participant ? response.data.roles.participant.summary.latestCompleted : '';

                        const dateObj = {
                            startDate: startDate !== '' ? _format(new Date(startDate), 'MM/DD/YYYY') : '',
                            endDate: endDate !== '' ? _format(new Date(endDate), 'MM/DD/YYYY') : '',
                            now: _format(Date.now(), 'MM/DD/YYYY'),
                        };

                        if (!participant || !startDate || !dateObj) {
                            setNoProgress(true);
                        }

                        setHeaderProps({
                            groupLabel: participant && participant ? group.fields.clientLabel : '',
                            providerList: participant && participant ? group.parentRoles.providerList : [],
                            dates: dateObj,
                            participant:
                                participant && participant ? response.data.roles.participant.fields.participantId : '',
                        });
                        setLoading(false);
                    });
            } catch (e) {
                console.error(e);
            }
        })();
    }, [props.filters]);

    if (noProgress) {
        return <NoGroupRole type="data" />;
    }

    if (props.noGroups) {
        return <NoGroupRole type="group" />;
    }

    if (props.noParticipants) {
        return <NoGroupRole type="participant" />;
    }

    if (loading) {
        return <Loader loading />;
    }

    const switchView = () => {
        setShowPrintMode(!showPrintMode);
    };

    return loading && loading ? (
        <Loader loading />
    ) : (
        <Report showPagination={showPrintMode}>
            <Page>
                <BrowserOnly>
                    <PrintView showPrintMode={showPrintMode} switchView={switchView} />
                </BrowserOnly>
                <div className={reportStyle.reportBox}>
                    <ReportHeader {...headerProps} />
                    <div className={reportStyle.reportBody}>{titleAndDescription}</div>
                    <div style={{ marginBottom: '2em' }}>{mainCharts}</div>
                </div>
            </Page>
            <Page>
                <div style={{ marginTop: '2em' }}>
                    <h3 style={{ color: '#007298', textAlign: 'center' }}>Individual Progress Areas</h3>
                    {progressCharts}
                </div>
            </Page>
        </Report>
    );
};

Component.propTypes = {
    settings: PropTypes.object,
    isPreview: PropTypes.bool,
    filters: PropTypes.object,
    widgets: PropTypes.object,
    data: PropTypes.object,
};

// reportTemplatePlayer wraps the Report Player with the Filter Bar. This is also where the FilterBar lives and you define your filters. The filters are passed to the Player and Widgets.
export default reportTemplatePlayer({
    widgets,
    getFilterFields: props => {
        return getActualFields(filterFields, props);
    },
})(Component);
